/**
 * @export
 */
export const AccountCapabilitiesCardStatusEnum = {
    Unactivated: 'unactivated',
    Active: 'active',
    Suspended: 'suspended',
    Canceled: 'canceled'
};
/**
 * @export
 */
export const AccountCapabilitiesCardAllowanceIntervalEnum = {
    Daily: 'daily',
    Weekly: 'weekly',
    Monthly: 'monthly',
    Continuous: 'continuous'
};
/**
 * @export
 */
export const AccountCapabilitiesVirtualCardStatusEnum = {
    Unactivated: 'unactivated',
    Active: 'active',
    Suspended: 'suspended',
    Canceled: 'canceled'
};
/**
 * @export
 */
export const AccountConnectionFeedBackendEnum = {
    Simulation: 'simulation',
    Cdf3: 'cdf3',
    EmburseCards: 'emburse_cards',
    AmexFins: 'amex_fins',
    CapitalOne: 'capital_one',
    AmexFiles: 'amex_files',
    AmexCpg: 'amex_cpg',
    VisaFiles: 'visa_files',
    Finicity: 'finicity',
    AmexCel: 'amex_cel',
    EfsFiles: 'efs_files'
};
/**
 * @export
 */
export const AccountConnectionStatusEnum = {
    Active: 'active',
    Disconnected: 'disconnected',
    Pending: 'pending',
    Deactivated: 'deactivated'
};
/**
 * @export
 */
export const ApprovalIntervalEnum = {
    Daily: 'daily',
    Weekly: 'weekly',
    Monthly: 'monthly',
    Continuous: 'continuous'
};
/**
 * @export
 */
export const AuthorizationStatusEnum = {
    Pending: 'pending',
    Closed: 'closed',
    Declined: 'declined'
};
/**
 * @export
 */
export const AuthorizationNetworkEnum = {
    Unknown: 'unknown',
    Amex: 'amex',
    Mastercard: 'mastercard',
    Visa: 'visa',
    Demo: 'demo',
    Discover: 'discover',
    DinersClub: 'diners-club'
};
/**
 * @export
 */
export const AuthorizationVirtualCardStatusEnum = {
    Unactivated: 'unactivated',
    Active: 'active',
    Suspended: 'suspended',
    Canceled: 'canceled',
    Pending: 'pending',
    LostOrStolen: 'lost_or_stolen'
};
/**
 * @export
 */
export const CardNetworkEnum = {
    Unknown: 'unknown',
    Amex: 'amex',
    Mastercard: 'mastercard',
    Visa: 'visa',
    Demo: 'demo',
    Discover: 'discover',
    DinersClub: 'diners-club'
};
/**
 * @export
 */
export const CardStatusEnum = {
    Unactivated: 'unactivated',
    Active: 'active',
    Suspended: 'suspended',
    Canceled: 'canceled',
    Pending: 'pending',
    LostOrStolen: 'lost_or_stolen'
};
/**
 * @export
 */
export const CardAllowanceIntervalEnum = {
    Daily: 'daily',
    Weekly: 'weekly',
    Monthly: 'monthly',
    Continuous: 'continuous'
};
/**
 * @export
 */
export const CardDetailNetworkEnum = {
    Unknown: 'unknown',
    Amex: 'amex',
    Mastercard: 'mastercard',
    Visa: 'visa',
    Demo: 'demo',
    Discover: 'discover',
    DinersClub: 'diners-club'
};
/**
 * @export
 */
export const CardDetailStatusEnum = {
    Unactivated: 'unactivated',
    Active: 'active',
    Suspended: 'suspended',
    Canceled: 'canceled',
    Pending: 'pending',
    LostOrStolen: 'lost_or_stolen'
};
/**
 * @export
 */
export const CardDetailApprovalsInnerIntervalEnum = {
    Daily: 'daily',
    Weekly: 'weekly',
    Monthly: 'monthly',
    Continuous: 'continuous'
};
/**
 * @export
 */
export const CardDetailShippingServiceEnum = {
    Standard: 'Standard',
    Express: 'Express',
    Priority: 'Priority'
};
/**
 * @export
 */
export const CardDetailShippingStatusEnum = {
    Pending: 'Pending',
    Shipped: 'Shipped',
    Delivered: 'Delivered',
    Returned: 'Returned',
    Failed: 'Failed',
    Canceled: 'Canceled'
};
/**
 * @export
 */
export const CardholderStatusEnum = {
    Pending: 'pending',
    Active: 'active',
    Deactivated: 'deactivated'
};
/**
 * @export
 */
export const CardholderDetailStatusEnum = {
    Pending: 'pending',
    Active: 'active',
    Deactivated: 'deactivated'
};
/**
 * @export
 */
export const ConnectionFeedBackendEnum = {
    Simulation: 'simulation',
    Cdf3: 'cdf3',
    EmburseCards: 'emburse_cards',
    AmexFins: 'amex_fins',
    CapitalOne: 'capital_one',
    AmexFiles: 'amex_files',
    AmexCpg: 'amex_cpg',
    VisaFiles: 'visa_files',
    Finicity: 'finicity',
    AmexCel: 'amex_cel',
    EfsFiles: 'efs_files'
};
/**
 * @export
 */
export const ConnectionStatusEnum = {
    Active: 'active',
    Disconnected: 'disconnected',
    Pending: 'pending',
    Deactivated: 'deactivated'
};
/**
 * @export
 */
export const ConnectionDetailFeedBackendEnum = {
    Simulation: 'simulation',
    Cdf3: 'cdf3',
    EmburseCards: 'emburse_cards',
    AmexFins: 'amex_fins',
    CapitalOne: 'capital_one',
    AmexFiles: 'amex_files',
    AmexCpg: 'amex_cpg',
    VisaFiles: 'visa_files',
    Finicity: 'finicity',
    AmexCel: 'amex_cel',
    EfsFiles: 'efs_files'
};
/**
 * @export
 */
export const ConnectionDetailStatusEnum = {
    Active: 'active',
    Disconnected: 'disconnected',
    Pending: 'pending',
    Deactivated: 'deactivated'
};
/**
 * @export
 */
export const CreateCardAllowanceIntervalEnum = {
    Daily: 'daily',
    Weekly: 'weekly',
    Monthly: 'monthly',
    Continuous: 'continuous'
};
/**
 * @export
 */
export const CreateCardCardholderStatusEnum = {
    Pending: 'pending',
    Active: 'active',
    Deactivated: 'deactivated'
};
/**
 * @export
 */
export const CreateCardShippingServiceEnum = {
    Standard: 'Standard',
    Express: 'Express',
    Priority: 'Priority'
};
/**
 * @export
 */
export const CreateCardShippingStatusEnum = {
    Pending: 'Pending',
    Shipped: 'Shipped',
    Delivered: 'Delivered',
    Returned: 'Returned',
    Failed: 'Failed',
    Canceled: 'Canceled'
};
/**
 * @export
 */
export const CreateVirtualCardAllowanceIntervalEnum = {
    Daily: 'daily',
    Weekly: 'weekly',
    Monthly: 'monthly',
    Continuous: 'continuous'
};
/**
 * @export
 */
export const CreateVirtualCardCardholderStatusEnum = {
    Pending: 'pending',
    Active: 'active',
    Deactivated: 'deactivated'
};
/**
 * @export
 */
export const EmbeddedCardImageCardFormatEnum = {
    Standard: 'standard',
    Minimal: 'minimal',
    Json: 'json'
};
/**
 * @export
 */
export const EmburseApiCompanyCompanyStatusEnum = {
    Pending: 'pending',
    Approved: 'approved',
    Rejected: 'rejected'
};
/**
 * @export
 */
export const EmburseApiCompanyCompanyVerificationStatusEnum = {
    Unsubmitted: 'unsubmitted',
    Pending: 'pending',
    Verified: 'verified',
    Unverified: 'unverified',
    Rejected: 'rejected'
};
/**
 * @export
 */
export const EmburseApiCompanyConnectionFeedBackendEnum = {
    Simulation: 'simulation',
    Cdf3: 'cdf3',
    EmburseCards: 'emburse_cards',
    AmexFins: 'amex_fins',
    CapitalOne: 'capital_one',
    AmexFiles: 'amex_files',
    AmexCpg: 'amex_cpg',
    VisaFiles: 'visa_files',
    Finicity: 'finicity',
    AmexCel: 'amex_cel',
    EfsFiles: 'efs_files'
};
/**
 * @export
 */
export const EmburseApiCompanyConnectionStatusEnum = {
    Active: 'active',
    Disconnected: 'disconnected',
    Pending: 'pending',
    Deactivated: 'deactivated'
};
/**
 * @export
 */
export const EventEventTypeEnum = {
    CardCreated: 'card.created',
    CardUpdated: 'card.updated',
    CardShippingUpdated: 'card.shipping_updated',
    VirtualCardCreated: 'virtualCard.created',
    VirtualCardUpdated: 'virtualCard.updated',
    AuthorizationCreated: 'authorization.created',
    AuthorizationExpired: 'authorization.expired',
    SettlementUpdated: 'settlement.updated',
    SettlementCorrected: 'settlement.corrected',
    SettlementsSynced: 'settlements.synced',
    StatementCreated: 'statement.created',
    ConnectionActive: 'connection.active',
    ConnectionCreated: 'connection.created',
    ConnectionDisconnected: 'connection.disconnected',
    ConnectionDeactivated: 'connection.deactivated',
    AccountCreated: 'account.created',
    AccountUpdated: 'account.updated',
    CardholderCreated: 'cardholder.created',
    CardholderUpdated: 'cardholder.updated',
    IssuingRequestCreated: 'issuingRequest.created',
    IssuingRequestUpdated: 'issuingRequest.updated'
};
/**
 * @export
 */
export const IssuingRequestStatusEnum = {
    Incomplete: 'incomplete',
    Valid: 'valid',
    Error: 'error',
    Issued: 'issued'
};
/**
 * @export
 */
export const IssuingRequestAllowanceIntervalEnum = {
    Daily: 'daily',
    Weekly: 'weekly',
    Monthly: 'monthly',
    Continuous: 'continuous'
};
/**
 * @export
 */
export const IssuingRequestIssuedVirtualCardStatusEnum = {
    Unactivated: 'unactivated',
    Active: 'active',
    Suspended: 'suspended',
    Canceled: 'canceled',
    Pending: 'pending',
    LostOrStolen: 'lost_or_stolen'
};
/**
 * @export
 */
export const IssuingRequestShippingServiceEnum = {
    Standard: 'Standard',
    Express: 'Express',
    Priority: 'Priority'
};
/**
 * @export
 */
export const IssuingRequestShippingStatusEnum = {
    Pending: 'Pending',
    Shipped: 'Shipped',
    Delivered: 'Delivered',
    Returned: 'Returned',
    Failed: 'Failed',
    Canceled: 'Canceled'
};
/**
 * @export
 */
export const SessionStatusEnum = {
    Pending: 'pending',
    Completed: 'completed',
    Failed: 'failed',
    Initialized: 'initialized',
    Connected: 'connected'
};
/**
 * @export
 */
export const SessionBrandingEnum = {
    Emburse: 'emburse',
    Abacus: 'abacus',
    Captio: 'captio',
    Certify: 'certify',
    CertifyAp: 'certify_ap',
    Chromeriver: 'chromeriver',
    EmburseCards: 'emburse_cards',
    EmburseSpend: 'emburse_spend',
    Nexonia: 'nexonia',
    Springahead: 'springahead',
    Tallie: 'tallie'
};
/**
 * @export
 */
export const SettlementTransactionTypeEnum = {
    Purchase: 'purchase',
    Payment: 'payment',
    Fee: 'fee',
    Transfer: 'transfer',
    Refund: 'refund',
    Adjustment: 'adjustment',
    Other: 'other',
    Reversal: 'reversal'
};
/**
 * @export
 */
export const SettlementNetworkEnum = {
    Unknown: 'unknown',
    Amex: 'amex',
    Mastercard: 'mastercard',
    Visa: 'visa',
    Demo: 'demo',
    Discover: 'discover',
    DinersClub: 'diners-club'
};
/**
 * @export
 */
export const SettlementAuthorizationStatusEnum = {
    Pending: 'pending',
    Closed: 'closed',
    Declined: 'declined'
};
/**
 * @export
 */
export const SettlementVirtualCardStatusEnum = {
    Unactivated: 'unactivated',
    Active: 'active',
    Suspended: 'suspended',
    Canceled: 'canceled',
    Pending: 'pending',
    LostOrStolen: 'lost_or_stolen'
};
/**
 * @export
 */
export const ShippingOptionServiceEnum = {
    Standard: 'Standard',
    Express: 'Express',
    Priority: 'Priority'
};
/**
 * @export
 */
export const SignupPartnerEnum = {
    Spend: 'spend'
};
/**
 * @export
 */
export const SignupOnboardingVersionEnum = {
    CardsDefault: 'cards-default',
    Cards2024Q2: 'cards-2024-q2',
    SpendInitial: 'spend-initial',
    Spend2024Q2: 'spend-2024-q2'
};
/**
 * @export
 */
export const UpdateCardStatusEnum = {
    Unactivated: 'unactivated',
    Active: 'active',
    Suspended: 'suspended',
    Canceled: 'canceled',
    Pending: 'pending',
    LostOrStolen: 'lost_or_stolen'
};
/**
 * @export
 */
export const UpdateCardAllowanceIntervalEnum = {
    Daily: 'daily',
    Weekly: 'weekly',
    Monthly: 'monthly',
    Continuous: 'continuous'
};
/**
 * @export
 */
export const UpdateVirtualCardStatusEnum = {
    Unactivated: 'unactivated',
    Active: 'active',
    Suspended: 'suspended',
    Canceled: 'canceled',
    Pending: 'pending',
    LostOrStolen: 'lost_or_stolen'
};
/**
 * @export
 */
export const VendorMerchantsInnerNetworkEnum = {
    Unknown: 'unknown',
    Amex: 'amex',
    Mastercard: 'mastercard',
    Visa: 'visa',
    Demo: 'demo',
    Discover: 'discover',
    DinersClub: 'diners-club'
};
/**
 * @export
 */
export const VirtualCardStatusEnum = {
    Unactivated: 'unactivated',
    Active: 'active',
    Suspended: 'suspended',
    Canceled: 'canceled',
    Pending: 'pending',
    LostOrStolen: 'lost_or_stolen'
};
/**
 * @export
 */
export const VirtualCardNetworkEnum = {
    Unknown: 'unknown',
    Amex: 'amex',
    Mastercard: 'mastercard',
    Visa: 'visa',
    Demo: 'demo',
    Discover: 'discover',
    DinersClub: 'diners-club'
};
/**
 * @export
 */
export const VirtualCardAllowanceIntervalEnum = {
    Daily: 'daily',
    Weekly: 'weekly',
    Monthly: 'monthly',
    Continuous: 'continuous'
};
/**
 * @export
 */
export const VirtualCardDetailStatusEnum = {
    Unactivated: 'unactivated',
    Active: 'active',
    Suspended: 'suspended',
    Canceled: 'canceled',
    Pending: 'pending',
    LostOrStolen: 'lost_or_stolen'
};
/**
 * @export
 */
export const VirtualCardDetailNetworkEnum = {
    Unknown: 'unknown',
    Amex: 'amex',
    Mastercard: 'mastercard',
    Visa: 'visa',
    Demo: 'demo',
    Discover: 'discover',
    DinersClub: 'diners-club'
};
/**
 * @export
 */
export const VirtualCardDuplicatesInnerStatusEnum = {
    Unactivated: 'unactivated',
    Active: 'active',
    Suspended: 'suspended',
    Canceled: 'canceled',
    Pending: 'pending',
    LostOrStolen: 'lost_or_stolen'
};
